import React from 'react'
import { CellProps, DatePicker, Input, InputNumber, Table } from 'rsuite'

const fieldMap = {
  string: Input,
  number: InputNumber,
  date: DatePicker
}

const { Cell } = Table

function toValueString (value: string | number | Date) {
  return value instanceof Date ? value?.toLocaleDateString() : value
}

interface EditableCellProps<T, K extends keyof T, V extends keyof T> extends CellProps {
  rowData: T
  idKey: K
  dataType: 'string' | 'number' | 'date'
  dataKey: V
  onChange: (id: K, key: V, value: T[V]) => void
  onEdit: (value: any) => void
}

export const EditableCell = ({ rowData, idKey, dataType, dataKey, onChange, onEdit, ...props }: EditableCellProps) => {
  const editing = rowData.status === 'EDIT'

  const Field: typeof Input | typeof InputNumber | typeof DatePicker = fieldMap[dataType]
  const value = rowData[dataKey]
  const text = toValueString(value)
  return (
    <Cell
      {...props}
      className={editing ? 'table-cell-editing' : ''}
      onDoubleClick={() => {
        onEdit?.(rowData.id)
      }}
    >
      {editing ? (
        <Field
          defaultValue={value}
          onChange={value => {
            onChange(rowData[idKey], dataKey, value)
          }}
        />
      ) : (
        text
      )}
    </Cell>
  )
}